import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
vue.use(vuex);

//store
const desagregacionpoblacional = new vapi({
    namespaced : true,
    baseURL: `${process.env.VUE_APP_REST}/api/desagregacionpoblacional`,
    state: {
        Adesagregacionpoblacional: []
    }
}).get({
    action: "get_desagregacionpoblacional",   
    onSuccess: (state, payload ) => {
        state.Adesagregacionpoblacional = payload.data;
    }
}).getStore();

desagregacionpoblacional.getters = {
    gdesagregacionpoblacional: state => {
        return state.Adesagregacionpoblacional;
    }
}

export default desagregacionpoblacional;